module.exports = __webpack_public_path__ + "static/media/11.abf15ec1.jpg";